import { createGroup } from '../actions/calendarGroupActions';
import { lazyCreateGroup, UserType } from 'owa-group-create-integration';
import { lazyCreateGroupV2 } from 'owa-group-create-integration-v2';
import { IsShareableCRUDEnabled } from 'owa-groups-shared-store/lib/utils/shareableCRUDFlight';
import { getCurrentLanguage, getCurrentCulture } from 'owa-localize';
import { getUserConfiguration, isConsumer } from 'owa-session-store';
import { orchestrator } from 'satcheljs';

function onGroupCreated(groupSmtp?: string) {
    if (groupSmtp) {
        // TODO VSO# 29350: When a group is created then load the groups and select the newly created group
    }
}

orchestrator(createGroup, async actionMessage => {
    if (IsShareableCRUDEnabled()) {
        const createGroup = await lazyCreateGroupV2.import();
        let sessionSettings = getUserConfiguration().SessionSettings;
        createGroup(
            sessionSettings.ExternalDirectoryUserGuid,
            getCurrentLanguage(),
            getCurrentCulture(),
            'Calendar',
            onGroupCreated
        );
    } else {
        const createGroup = await lazyCreateGroup.import();
        const usertype = isConsumer() ? UserType.Consumer : UserType.Enterprise;
        createGroup(usertype, getCurrentCulture(), 'Calendar', onGroupCreated);
    }
});
